import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { DutyPlannerService } from '../../../services/DutyPlanner/DutyPlannerService'

interface IDutyPlannerDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  id: number
  leastDestructiveRef: React.RefObject<HTMLButtonElement>
  onDelete: () => void
}

export default function DutyPlannerDeleteDialog({
  isOpen,
  onClose,
  id,
  leastDestructiveRef,
  onDelete
}: IDutyPlannerDeleteDialogProps) {
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()
  const service = new DutyPlannerService()

  const handleDelete = async () => {
    if (!id) return
    setIsLoading(true)
    try {
      await service.delete(id)
      toast({ title: 'Evento excluído com sucesso', status: 'success', duration: 3000, isClosable: true })
      onDelete()
    } catch {
      toast({ title: 'Erro ao excluir evento', status: 'error', duration: 3000, isClosable: true })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          Remover feriado/plantão
        </AlertDialogHeader>
        <AlertDialogBody>Tem certeza que deseja remover este evento? Esta ação não poderá ser desfeita.</AlertDialogBody>
        <AlertDialogFooter>
          <Button onClick={onClose} variant="outline">
            Cancelar
          </Button>
          <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
            Remover
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
